const weekVersion = new Date().getDate();

export const get = async ({key, callFunc, onSuccess, onCache, shouldLoadCache, version = weekVersion}) => {

  if (shouldLoadCache) {
    const cachedVersion = localStorage.getItem(`${key}_version`);
    if (cachedVersion !== version.toString()) {
      localStorage.removeItem(key);
      localStorage.setItem(`${key}_version`, version.toString());
    }
    const cached = localStorage.getItem(key);
    if(cached) {
      onCache(JSON.parse(cached));
    }
  }
  const results = await callFunc();
  const toCache = onSuccess(results);
  try {
    localStorage.setItem(key, JSON.stringify(toCache));
  } catch {
    localStorage.removeItem(key);
    console.log('Local storage is full, cannot cache');
  }
  return toCache;
}
export default {
  get,

}
